const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;

export const subscribeToResendAudience = async ({
    email,
    firstName,
    lastName,
    role,
}) => {
    try {
        const response = await fetch(
            `${supabaseUrl}/functions/v1/add-user-to-resend`,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, firstName, lastName, role }),
            }
        );

        const result = await response.json();

        if (!response.ok) {
            console.error("Failed to subscribe:", result);
            throw new Error(
                result.error || "Failed to subscribe to Resend audience"
            );
        }

        return result.data;
    } catch (error) {
        console.error("Unexpected error subscribing to Resend audience:", error);
        throw error;
    }
}